import extractBlueBillywigTokensFromUrl from 'js/lib/helpers/extractTokensFromVideoUrl/blueBillywig'
import extractKalturaTokensFromUrl from 'js/lib/helpers/extractTokensFromVideoUrl/kaltura'
import extractVimeoTokensFromUrl from 'js/lib/helpers/extractTokensFromVideoUrl/vimeo'
import extractYoutubeTokensFromUrl from 'js/lib/helpers/extractTokensFromVideoUrl/youtube'

import { VideoPlatform } from '../constants'

const tokenExtractorFunctions = [
    extractYoutubeTokensFromUrl,
    extractVimeoTokensFromUrl,
    extractKalturaTokensFromUrl,
    extractBlueBillywigTokensFromUrl,
]

export type VideoTokens = {
    type: VideoPlatform
    id: string
}

export default function getVideoFromUrl(value?: string): VideoTokens | null {
    let tokens: VideoTokens | null = null

    if (value) {
        for (const tokenExtractorFunction of tokenExtractorFunctions) {
            const extractedTokens = tokenExtractorFunction(value)

            if (extractedTokens?.id) {
                tokens = extractedTokens
                break
            }
        }
    }

    return tokens
}
